import {
  IWidgetConfigurationProps,
  withWidgetConfiguration,
} from "@sgwt-widget/core";
import { Component, h } from "preact";
import { Format } from "../../common/utils/format";
// tslint:disable-next-line:interface-name
interface Props {
  onChange: (value: string) => void;
  widgetTextType: string;
  textValue: string;
}
// tslint:disable-next-line:interface-name
interface State {
  text: string;
}

let errorMsg = "";
let showErrormsg = false;
export class TextBoxComponentClass extends Component<
  Props & IWidgetConfigurationProps,
  State
> {
  public componentDidMount() {
    this.setState({ text: this.props.textValue });
  }

  public componentWillMount() {
    this.props.onChange(this.props.textValue);
  }

  public render() {
    switch (this.props.widgetTextType) {
      case "text": {
        if (
          this.props.textValue.length > 0 &&
          typeof Number(this.props.textValue) === "number"
        ) {
          errorMsg = "Please enter only text.";
          showErrormsg = true;
        }
        break;
      }
      case "number": {
        if (
          this.props.textValue.length > 0 &&
          typeof Number(this.props.textValue) !== "number"
        ) {
          errorMsg = "Please enter only numeric values.";
          showErrormsg = true;
        }
        break;
      }
    }
    let text = "";
    text =
      this.props.textValue && this.props.textValue.length > 0
        ? this.props.textValue
        : "";

    return (
      <div class="form-group">
        <div class="row">
          <div class="col-sm-6">
            <input
              type="text"
              onChange={this.valueChanged.bind(this)}
              value={text}
            />
          </div>
          <div class="col-sm-6" style={Format.GetDivStyle(showErrormsg)}>
            {errorMsg}
          </div>
        </div>
      </div>
    );
  }
  private valueChanged(value: any) {
    this.setState({
      text: value && value.path[0].value > 0 ? value.path[0].value : "",
    });
    this.props.onChange(this.state.text);
  }
}

export const TextBoxComponent = withWidgetConfiguration(TextBoxComponentClass);
